import { Outlet } from 'react-router-dom'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

function Entry() {
  return (
    <div className="body">
      <Header />
      <main className="main-container">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

export default Entry